import { defineComponent, onMounted } from "vue";
import GoodList from "./components/GoodList.vue";
import data from "@/utils/goods";
export default defineComponent({
  name: "ABOUT",
  components: {
    GoodList
  },

  setup() {
    let refs;

    const bindRef = el => {
      refs = el;
    };

    onMounted(() => {
      console.log(123, refs);
    });
    return {
      bindRef,
      data
    };
  }

});